import { Box, Divider, Typography } from "@mui/material";

export function DetailRow({
    label,
    value,
}: {
    label: string;
    value: React.ReactNode;
}) {
    return (
        <>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    minHeight: 40,
                    px: 2,
                }}
            >
                <Typography variant="body2" color="text.secondary">
                    {label}
                </Typography>

                <Box>
                    <Typography
                        variant="body2"
                        fontWeight={500}
                        component="span"
                    >
                        {value}
                    </Typography>
                </Box>
            </Box>
            <Divider />
        </>
    );
}
